const DEFAULT_LOAD_TIMEOUT_MS = 5000;
const LOAD_POLL_INTERVAL_MS = 50;

type LoadingSnapshot<T> = {
  value: T;
  loading: boolean;
};

export async function waitForLoadedValue<T>({
  getSnapshot,
  timeoutMs = DEFAULT_LOAD_TIMEOUT_MS,
}: {
  getSnapshot: () => LoadingSnapshot<T>;
  timeoutMs?: number;
}): Promise<T> {
  const startedAt = Date.now();
  let snapshot = getSnapshot();
  while (snapshot.loading && Date.now() - startedAt < timeoutMs) {
    await delay(LOAD_POLL_INTERVAL_MS);
    snapshot = getSnapshot();
  }
  return snapshot.value;
}

function delay(milliseconds: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, milliseconds);
  });
}
